import { render, staticRenderFns } from "./NewMessengerConversationUploadedFiles.vue?vue&type=template&id=d7850f20&scoped=true"
import script from "./NewMessengerConversationUploadedFiles.vue?vue&type=script&lang=js"
export * from "./NewMessengerConversationUploadedFiles.vue?vue&type=script&lang=js"
import style0 from "./NewMessengerConversationUploadedFiles.vue?vue&type=style&index=0&id=d7850f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7850f20",
  null
  
)

export default component.exports